import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HierarchyItem } from './hierarchy-item';

@Component({
  selector: 'bom-items-hierarchy',
  templateUrl: './items-hierarchy.component.html',
  styleUrls: ['./items-hierarchy.component.scss'],
})
export class ItemsHierarchyComponent {
  @Input()
  items$: Observable<HierarchyItem[]>;

  @Input()
  addedItemIds$: Observable<string[]>;

  @Input()
  infos$: Observable<{ [id: string]: string }>;

  @Input()
  addButtonTextKey: 'Add' | 'Choose' = 'Add';

  @Input()
  isAddDisabled$: Observable<boolean> = of(false);

  @Output()
  clickInfoIcon = new EventEmitter<HierarchyItem>();

  @Output()
  clickAdd = new EventEmitter<HierarchyItem>();

  expandedItemIds: { [id: string]: boolean } = {};

  toggleExpand(item: HierarchyItem) {
    this.expandedItemIds[item.title] = !this.expandedItemIds[item.title];
  }

  trackByFn(index: number, item: HierarchyItem) {
    return item.id;
  }
}
